function userInitials(name, email) {
    const trimmedName = typeof name === 'string' ? name.trim() : '';

    if (trimmedName) {
        const parts = trimmedName.split(/[\s\-]+/).filter(Boolean);

        if (parts.length >= 2) {
            return (parts[0].charAt(0) + parts[parts.length - 1].charAt(0)).toUpperCase();
        }

        return trimmedName.slice(0, 2).toUpperCase();
    }

    const trimmedEmail = typeof email === 'string' ? email.trim() : '';

    if (trimmedEmail) {
        return trimmedEmail.split('@')[0].slice(0, 2).toUpperCase();
    }

    return '?';
}

module.exports = { userInitials };
